module.exports = __webpack_public_path__ + "img/funding-usd-currency.d2dd022.svg";